
/**
 * Decorator para sinalizar que a classe trata-se de uma representação de action
 * possível sobre a store. Encapsula operações comuns de CRUD. Necessário que a classe que usa o 
 * decorator extenda a class GenericStoreAction
 * @param prefix Prefixo da action (exibido no store dev tolls )
 */
export function StoreAction(prefix){
    return function<T extends {new(...args:any[]):{}}>(constructor:T) {
        return class extends constructor {

            public static getItems: string = `[${prefix}] get_items`;
            
            public static getItemsSuccess: string = `[${prefix}] get_items_success`;
            public static getItemsError: string = `[${prefix}] get_items_error`;
        
            public static selectItem: string = `[${prefix}] select_item`;
            public static selectItemSuccess: string = `[${prefix}] select_item_success`;
            public static selectItemError: string = `[${prefix}] select_item_error`;
        
            public static deleteItem: string = `[${prefix}] delete_item`;
            public static deleteItemSuccess: string = `[${prefix}] delete_item_success`;
            public static deleteItemError: string = `[${prefix}] delete_item_error`;
        
            public static updateItem: string = `[${prefix}] update_item`;
            public static updateItemSuccess: string = `[${prefix}] update_item_success`;
            public static updateItemError: string = `[${prefix}] update_item_error`;
        
            public static createItem: string = `[${prefix}] create_item`;
            public static createItemSuccess: string = `[${prefix}] create_item_success`;
            public static createItemError: string = `[${prefix}] create_item_error`;
        }
    }
}